const orgData = state => {
  return state.orgData
}

const orgListTotal = state => {
  return state.total
}

const selectedOrg = (state) => {
  return state.selectedOrg
}

const getOrgFeatureEligibility = state => feature => {
  return state.orgFeatures.find(f => String(f.feature).toUpperCase() === String(feature).toUpperCase()) || {}
}

const eligibleFeatures = state => {
  return state.orgFeatures.reduce((acc, f) => f.isEligible ? [...acc, String(f.feature).toUpperCase()] : acc, [])
}

const orgFlags = (state) => {
  return state.orgFlags || []
}

const enabledFlags = state => {
  return (state.orgFlags || [])
    .filter(({ name, optIn }) => optIn)
    .map(({ name }) => name)
}

export default {
  orgListTotal,
  selectedOrg,
  orgData,
  getOrgFeatureEligibility,
  eligibleFeatures,
  orgFlags,
  enabledFlags,
}
